import { useState } from 'react'
import React from 'react'
import axios from 'axios'
import { Table } from 'antd'

export default function APP() {
  const [loading, setLoading] = useState(false)
  const [publishedAt, setPublishedAt] = useState('')
  const [data, setData] = useState([])
  const fetchData = async () => {
    setLoading(true)
    const result = await axios(`/euro`)
    setLoading(false)
    setData(result.data.ticker)
    setPublishedAt(result.data.publishedAt)
  }
  React.useEffect(() => {
    fetchData()
  }, [])
  const paginationProps = {
    hideOnSinglePage: false,
    showSizeChanger: false,
    pageSize: 100 // 每页数据条数
  }
  const columns = [
    {
      title: '货币名称',
      dataIndex: 'currency'
    },
    {
      title: '现汇买入价',
      dataIndex: 'buy'
    },
    {
      title: '现汇卖出价',
      dataIndex: 'sell'
    }
  ]
  return (
    <>
      <div style={{ marginBottom: '20px' }}>更新时间：{publishedAt}</div>
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey="currency"
        pagination={paginationProps}
      />
    </>
  )
}
